import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Layout from "../components/Layout";
import BackButton from "../components/BackButton";
import { getBooking, setBooking } from "../lib/bookingState";

const EXAMES = [
  { id: 51, nome: "Espirometria" },
  { id: 52, nome: "Polissonografia" },
  { id: 272, nome: "Pletismografia" },
];

export default function AgendarExame() {
  const navigate = useNavigate();
  const booking = getBooking();

  if (!booking.patient_id) {
    navigate("/agendar", { replace: true });
    return null;
  }

  function selecionar(exame) {
    setBooking({
      tipo_agendamento: "exame",
      procedimento_id: exame.id,
      procedimento_nome: exame.nome,
      especialidade_id: "",
      especialidade_nome: exame.nome,
      profissional_id: undefined,
      profissional_nome: undefined,
      data_hora: undefined,
      local_id: undefined,
    });

    navigate("/agendar/profissional");
  }

  return (
    <Layout>
      <BackButton to="/agendar/tipo" />

      <div className="fade-up">
        <h1 className="text-2xl sm:text-3xl tracking-tight font-bold text-slate-900" style={{ fontFamily: "Manrope" }}>
          Qual exame deseja marcar?
        </h1>
        <p className="text-slate-600 mt-2 text-sm">
          Selecione o procedimento desejado.
        </p>
      </div>

      <div className="mt-6 space-y-3">
        {EXAMES.map((exame) => (
          <button
            key={exame.id}
            onClick={() => selecionar(exame)}
            className="w-full bg-white border border-slate-200 rounded-2xl p-5 text-left hover:shadow-md transition-all flex items-center justify-between"
          >
            <span className="font-medium text-slate-900">{exame.nome}</span>
            <ChevronRight size={18} className="text-slate-400" />
          </button>
        ))}
      </div>
    </Layout>
  );
}
